

const Booked = () => {
  return (
    <div className="bg-primary rounded-2 text-white px-5 py-3">
      BOOKED
      </div>
  )
}

export default Booked;